<div class="modal-header">
	<h4 class="modal-title">{{orderWaitingMyApprove.productCode}} // {{orderWaitingMyApprove.productName}} </h4>
	
	<button type="button" class="close" aria-label="Close" (click)="modalClose()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body">
	<div class="alert alert-solid-brand alert-bold" role="alert">
		<div class="alert-icon"><i class="flaticon-warning"></i></div>
		<div class="alert-text">
			Ürünün {{orderWaitingMyApprove.toAddressName}} noktasına yapılan daha onceki sevkiyatları gösterilmektedir.
		</div>
		<div class="alert-close">
			<button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="modalClose()">
				<span aria-hidden="true"><i class="la la-close"></i></span>
			</button>
		</div>
	</div>

	<h5 class="text-center">{{orderWaitingMyApprove.toAddressName}}</h5>

	<!--<h5 class="text-center">{{orderWaitingMyApprove.sourceAddressName}}</h5>-->

	<ng-container *ngIf="(isLoading | async)">

		<!-- <p>{{message}}</p> -->
		<table class="table table-striped" *ngIf="(productHistories | async).length > 0">
			<thead>
				<tr>
					<th>Tarih</th>
					<th>Çıkış Yeri</th>
					<th>Miktar</th>
					<th>Açıklama</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let productHistory of (productHistories | async)">
					<td>{{productHistory.formatedDate}}</td>
					<td>{{productHistory.kaynakAddress}}</td>
					<td>{{productHistory.quantity}}</td>
					<td>{{productHistory.durum}}</td>
				</tr>
				<tr>
					<td colspan="4" align="right">
						<h5>Toplam: {{(sumAmount | async)}}</h5>
					</td>
				</tr>
			</tbody>
		</table>
		<div *ngIf="(productHistories | async).length < 1">Kayıt Bulunamadı.</div>

	</ng-container>
	<div class="text-center" *ngIf="!(isLoading | async)">
		<ng-container>
			<!--Spinner buraya konulacak-->
			<i class="fa fa-spinner fa-pulse fa-lg fa-fw"></i>
		</ng-container>
	</div>
</div>
<div class="modal-footer">
	
	<button type="button" class="btn btn-light" (click)="modalClose()">KAPAT</button>
</div>
